import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { AlertCardComponent } from '@shared/components/alert-card/alert-card.component';
import { RegraTributariaNaturezaOperacaoStruct } from '@shared/services/structs/motor-fiscal/regra-tributaria-natureza-operacao.struct';

/**
 * Seção "Regra Padrão" da aba Reforma Tributária.
 * Réplica estrutural da seção de regra das demais abas, mas como a Reforma faz um
 * vínculo a uma regra tributária cadastrada (e não preenche campos fiscais aqui),
 * o corpo exibe o vínculo selecionado ou o estado vazio.
 */
@Component({
    selector: 'app-reforma-tributo-regra-section',
    standalone: true,
    imports: [CommonModule, MatIconModule, MatButtonModule, MatMenuModule, AlertCardComponent],
    templateUrl: './tributo-regra-section.component.html',
    styleUrl: './tributo-regra-section.component.css',
})
export class ReformaTributoRegraSectionComponent {
    @Input() regra: RegraTributariaNaturezaOperacaoStruct | null = null;
    // Mapa codigo -> nome do modelo de documento (proprietario db_dfe); resolvido no tab e repassado.
    @Input() nomeModeloPorCodigo: Record<string, string> = {};
    /** Aba ativa e vínculo ainda não feito: exibe o erro de obrigatoriedade na seção. */
    @Input() pendente = false;
    @Output() selecionarRegra = new EventEmitter<void>();
    @Output() cadastrarRegra = new EventEmitter<void>();
    @Output() editarRegra = new EventEmitter<RegraTributariaNaturezaOperacaoStruct>();
    @Output() removerRegra = new EventEmitter<void>();
}
